import type { VehicleGroup } from "@/types/fleet";
import { apiRequest } from "@/lib/api/http";
import { logCrud } from "@/lib/activity/emit-store";

interface RemoteGroup {
  id: string;
  title: string;
  description?: string;
  client_id?: string;
}

interface ListResponse<T> {
  success: true;
  data: T[];
}

const groupColors = [
  "#3b82f6",
  "#22c55e",
  "#f59e0b",
  "#8b5cf6",
  "#ef4444",
  "#06b6d4",
  "#ec4899",
  "#84cc16",
  "#f97316",
  "#6366f1",
];

function colorForGroup(id: string) {
  let hash = 0;
  for (let i = 0; i < id.length; i += 1) {
    hash = (hash << 5) - hash + id.charCodeAt(i);
    hash |= 0;
  }
  return groupColors[Math.abs(hash) % groupColors.length];
}

function mapGroup(group: RemoteGroup): VehicleGroup {
  return {
    id: group.id,
    name: group.title,
    color: colorForGroup(group.id),
    vehicleCount: 0,
  };
}

export async function listGroups(): Promise<VehicleGroup[]> {
  const response = await apiRequest<ListResponse<RemoteGroup>>("/api/groups", {
    method: "GET",
    cache: "no-store",
  });
  return response.data.map(mapGroup);
}

export async function createGroup(input: { name: string }): Promise<void> {
  const response = await apiRequest<{ success: true; id: string }>("/api/groups", {
    method: "POST",
    body: JSON.stringify({
      title: input.name,
      description: "",
    }),
  });
  logCrud("create", "group", input.name, response.id);
}

export async function updateGroup(id: string, input: { name: string }): Promise<void> {
  await apiRequest<{ success: true }>(`/api/groups/${id}`, {
    method: "PUT",
    body: JSON.stringify({
      title: input.name,
    }),
  });
  logCrud("update", "group", input.name, id);
}

export async function deleteGroup(id: string): Promise<void> {
  await apiRequest<{ success: true }>(`/api/groups/${id}`, {
    method: "DELETE",
  });
  logCrud("delete", "group", "", id);
}

